import { Immutable } from "immer";
import React from "react";

import type { GetOffModalBlock as GetOffModalBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: GetOffModalBlockValue }>;

export const GetOffModalBlock = (props: IProps): React.JSX.Element => {
    return (
        <div className={styles.promoModalContent}>
            <div className="promo-modal__pre-header">
                &mdash; Limited Time Only &mdash;
            </div>
            <h1 className={styles.promoModalHeader}>{props.value.offer}</h1>
            <div className={styles.promoModalSubHeader}>
                Use Code: <strong>{props.value.codeCopy}</strong>
            </div>
            <a
                className={concatClassNames([
                    styles.promoModalButton,
                    "button",
                    "al-link--upgrade-now",
                ])}
                href="#"
                id="upgrade-now-btn"
            >
                Continue
            </a>
            <img
                className={styles.promoModalImage}
                src={props.value.image?.url}
                loading="lazy"
                decoding="async"
            />
            <div className={styles.promoModalDetails}></div>
        </div>
    );
};
